<template>
	<div class="register-wrapper">
		<div class="background-gradient"></div>
		<div class="register-container">
			<div class="register-box">
				<div class="box-header">
					<img src="https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250526105222_162.png"
						alt="至码云 logo" class="logo" />
					<h2 class="register-title">注册</h2>
					<p class="subtitle">至码云 API 开放平台</p>
					<div class="login-link">
						<span>已有账号？</span>
						<router-link to="/login">立即登录</router-link>
					</div>
				</div>

				<el-form :model="userInfor" :rules="rules" ref="registerForm" class="register-form">
					<el-form-item prop="account">
						<el-input v-model="userInfor.account" placeholder="请输入用户名" prefix-icon="el-icon-user"
							size="medium"></el-input>
					</el-form-item>

					<el-form-item prop="password">
						<el-input v-model="userInfor.password" placeholder="请输入密码 (不少于 8 位)" type="password"
							prefix-icon="el-icon-lock" size="medium"></el-input>
					</el-form-item>

					<el-form-item prop="code">
						<div class="code-wrapper">
							<el-input v-model="userInfor.code" placeholder="请输入验证码" prefix-icon="el-icon-picture"
								size="medium"></el-input>
							<img :src="image_url || defaultCaptcha" alt="验证码"
								@click="change" class="code-img" />
						</div>
					</el-form-item>

					<el-form-item prop="agreedToTerms">
						<el-checkbox v-model="agreedToTerms" class="terms-checkbox">
							我已阅读并同意 <a href="#" @click.prevent>使用条款</a> 及 <a href="#" @click.prevent>隐私政策</a>
						</el-checkbox>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" class="register-button" @click="goregister()"
							:loading="isRegisterLoading" :disabled="!agreedToTerms" size="medium">
							注册
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfor: {
					account: "",
					password: "",
					uuid: "",
					code: "",
				},
				image_url: "",
				defaultCaptcha: 'https://picsum.photos/120/40',
				agreedToTerms: false,
				rules: {
					account: [{
							required: true,
							message: "请输入用户名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 20,
							message: '用户名长度在 2 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 8,
							message: '密码长度不能少于 8 个字符',
							trigger: 'blur'
						}
					],
					code: [{
						required: true,
						message: '请输入图形验证码',
						trigger: 'blur'
					}]
				},
				isRegisterLoading: false
			};
		},
		methods: {
			async getcode() {
				try {
					let res;
					if (this.$api && this.$api.getCaptcha && this.$api.getCaptcha.get) {
						res = await this.$api.getCaptcha.get();
					} else {
						res = {
							code: 200,
							data: {
								uuid: Math.random().toString(36).substr(2, 10),
								image_url: `https://picsum.photos/120/40?random=${Math.random()}`
							}
						};
					}

					if (res && res.code === 200 && res.data) {
						this.userInfor.uuid = res.data.uuid;
						this.image_url = res.data.image_url;
					}
				} catch (err) {
					console.error("验证码获取失败：", err);
					this.image_url = this.defaultCaptcha;
				}
			},

			change() {
				this.getcode();
			},

			async goregister() {
				if (!this.agreedToTerms) {
					if (this.$message) {
						this.$message.warning("请先阅读并同意使用条款");
					}
					return;
				}

				try {
					await this.$refs.registerForm.validate();
					this.isRegisterLoading = true;

					let res;
					if (this.$api && this.$api.register && this.$api.register.post) {
						res = await this.$api.register.post(this.userInfor);
					} else {
						this.$message.warning("接口请求失败：封装 api 错误");
					}

					if (res && res.code === 200) {
						if (this.$message) {
							this.$message.success("注册成功，即将跳转到登录页面");
						}
						setTimeout(() => {
							this.$router.push('/login').catch(err => {
								console.error("跳转失败：", err);
								window.location.href = "/login";
							});
						}, 1000);
					} else {
						if (this.$message) {
							this.$message.error(res?.msg || "注册失败");
						}
						this.getcode();
					}
				} catch (err) {
					console.error("注册异常：", err);
					if (this.$message) {
						this.$message.error("请填写完整注册信息");
					}
				} finally {
					this.isRegisterLoading = false;
				}
			}
		},
		created() {
			this.getcode();
		},
	};
</script>

<style lang="scss" scoped>
	.register-wrapper {
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
		padding: 20px;
	}

	.background-gradient {
		position: absolute;
		inset: 0;
		z-index: 0;
		background: radial-gradient(125% 125% at 50% 90%, #fff 40%, #475569 100%);
	}

	.register-container {
		width: 100%;
		max-width: 420px;
		position: relative;
		z-index: 1;
		animation: fadeIn 0.5s ease-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.register-box {
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(20px);
		border-radius: 24px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		padding: 45px 40px;
		border: 1px solid rgba(255, 255, 255, 0.5);

		.box-header {
			text-align: center;
			margin-bottom: 35px;

			.logo {
				width: 75px;
				height: 75px;
				margin-bottom: 18px;
				border-radius: 16px;
				object-fit: contain;
			}

			.register-title {
				font-size: 26px;
				font-weight: 600;
				color: #1a1a1a;
				margin: 0 0 8px 0;
			}

			.subtitle {
				font-size: 14px;
				color: #666;
				margin: 0 0 16px 0;
			}

			.login-link {
				font-size: 14px;
				color: #666;

				a {
					color: #333;
					font-weight: 500;
					text-decoration: none;
					margin-left: 4px;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}

		.register-form {
			.el-form-item {
				margin-bottom: 22px;
			}

			::v-deep .el-input {
				.el-input__inner {
					height: 50px;
					border-radius: 16px;
					border: 1px solid #e0e0e0;
					transition: all 0.3s ease;
					font-size: 15px;
					background: #fff;
					padding-left: 48px;

					&:focus {
						border-color: #333;
						box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
					}

					&::placeholder {
						color: #bbb;
					}
				}

				.el-input__prefix {
					left: 18px;
					color: #888;
					font-size: 18px;
					top: 50%;
					transform: translateY(-50%);
				}
			}

			.code-wrapper {
				display: flex;
				gap: 14px;

				.el-input {
					flex: 1;
				}

				.code-img {
					width: 135px;
					height: 50px;
					border-radius: 16px;
					cursor: pointer;
					transition: all 0.3s ease;
					border: 1px solid #e0e0e0;
					object-fit: contain;
					flex-shrink: 0;
					background: #fff;
					padding: 2px;

					&:hover {
						opacity: 0.9;
						transform: scale(1.02);
						border-color: #333;
					}
				}
			}

			.terms-checkbox {
				::v-deep .el-checkbox__label {
					font-size: 13px;
					color: #4a4a68;

					a {
						color: #333;
						text-decoration: none;
						transition: all 0.3s ease;

						&:hover {
							text-decoration: underline;
						}
					}
				}

				::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
					background: #1a1a1a;
					border-color: #1a1a1a;
				}
			}

			.register-button {
				width: 100%;
				height: 50px;
				background: #1a1a1a;
				border: none;
				border-radius: 16px;
				font-size: 16px;
				font-weight: 500;
				color: #fff;
				letter-spacing: 2px;
				transition: all 0.3s ease;

				&:hover:not(:disabled) {
					background: #333;
					transform: translateY(-2px);
					box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
				}

				&:active:not(:disabled) {
					transform: translateY(0);
				}

				&:disabled {
					opacity: 0.5;
					cursor: not-allowed;
					background: #999;
				}
			}
		}
	}

	@media (max-width: 480px) {
		.register-box {
			padding: 35px 28px;
			border-radius: 20px;

			.box-header {
				.logo {
					width: 65px;
					height: 65px;
					border-radius: 14px;
				}

				.register-title {
					font-size: 24px;
				}
			}

			.register-form {
				.el-form-item {
					margin-bottom: 20px;
				}

				::v-deep .el-input .el-input__inner {
					height: 48px;
					font-size: 14px;
					border-radius: 14px;
					padding-left: 45px;
				}

				::v-deep .el-input .el-input__prefix {
					left: 16px;
					font-size: 17px;
				}

				.code-wrapper {
					gap: 12px;
				}

				.code-wrapper .code-img {
					width: 115px;
					height: 48px;
					border-radius: 14px;
					object-fit: contain;
					background: #fff;
					padding: 2px;
				}

				.register-button {
					height: 48px;
					font-size: 15px;
					border-radius: 14px;
				}
			}
		}
	}
</style>